import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { FormControl } from 'react-bootstrap';
import cn from 'classnames';

import FormulaContainer from './FormulaContainer';

const Text = props => (
  <Field {...props} component={FormulaContainer}>
    <TextField />
  </Field>
);

const TextField = ({ bsClass, value, onChange, disabled }) => (
  <FormControl
    {...{ onChange, disabled }}
    value={value || ''}
    type="text"
    bsClass={cn('form-control', bsClass)}
  />
);

TextField.propTypes = {
  bsClass: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool
};

export default Text;
export { TextField };
